<template>
    <b-card>
        <b-alert variant="danger" :show="showAlert">
            {{ alert }}
        </b-alert>
        <b-alert variant="success" :show="showSuccessAlert">
            {{ alert }}
        </b-alert>
        <b-form @submit.prevent="updateDealer" class="mt-3">
            <b-form-group label="ID" label-cols-sm="3">
                <b-form-input :value="formData.id" disabled></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('general.iin')" label-cols-sm="3">
                <the-mask v-model="formData.iin" mask="############" class="form-control" required />
            </b-form-group>
            <b-form-group :label="$t('dealer.name')" label-cols-sm="3">
                <b-form-input v-model="formData.name"></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('dealer.industry')" label-cols-sm="3">
                <b-form-input v-model="formData.industry"></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('dealer.phone')" label-cols-sm="3">
                <the-mask v-model="formData.phoneNumber" mask="+7 (7##) ###-##-##"
                    placeholder="+7 (7__) ___-__-__" :masked="true" class="form-control" />
            </b-form-group>
            <b-form-group :label="$t('dealer.address')" label-cols-sm="3">
                <b-form-input v-model="oldAddress" disabled></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('dealer.newAddressCity')" label-cols-sm="3">
                <multiselect v-model="selectedCity" :options="cities" :close-on-select="true" :hide-selected="true" :show-no-results="false"
                            @search-change="findCity" :internal-search="false"
                            label="name" :placeholder="$t('general.enterValue')" :select-label="''">
                    <template slot="noOptions">
                        <span>
                            {{ $t('general.enterValue' )}}
                        </span>
                    </template>
                </multiselect>
            </b-form-group>
            <b-form-group v-show="selectedCity" :label="$t('dealer.newAddressStreet')" label-cols-sm="3">
                <multiselect v-model="selectedStreet" :options="streets" @input="addressSelected"
                            :close-on-select="true" :hide-selected="true" :showNoResults="false"
                            @search-change="findAddress" :internal-search="false"
                            label="name" :placeholder="$t('general.enterValue')" :select-label="''">
                    <template slot="noOptions">
                        <span>
                            {{ $t('general.enterValue' )}}
                        </span>
                    </template>
                </multiselect>
            </b-form-group>
            <b-form-group v-show="selectedStreet" :label="$t('dealer.newAddressHouse')" label-cols-sm="3">
                <vue-bootstrap-typeahead v-model="formData.addressHome" :data="houses" :serializer="h => h.name"
                    :min-matching-chars="1" />
            </b-form-group>
            <b-form-group :label="$t('dealer.ndsPayer')" label-cols-sm="3">
                <b-form-checkbox v-model="formData.isNdsPayer"></b-form-checkbox>
            </b-form-group>
            <b-form-group v-if="formData.isNdsPayer" :label="$t('dealer.ndsCertificateSeries')" label-cols-sm="3">
                <b-form-input v-model="formData.ndsCertificateSeries" required></b-form-input>
            </b-form-group>
            <b-form-group v-if="formData.isNdsPayer" :label="$t('dealer.ndsCertificateNum')" label-cols-sm="3">
                <b-form-input v-model="formData.ndsCertificateNumber" required></b-form-input>
            </b-form-group>
            <b-form-row class="justify-content-end mx-0">
                <b-button type="submit" variant="success" :disabled="isDisabled">
                    <save-icon title="" />&nbsp;{{ $t('general.save') }}
                </b-button>
            </b-form-row>
        </b-form>
    </b-card>
</template>

<script>
/* eslint-disable */
import { executeAfterTwoSeconds } from '@/utils/utils';

export default {
    name: 'EditDealerForm',
    props: {
        dealerId: Number
    },
    created() {
        this.getDealerData()
    },
    data () {
        return {
            showAlert: false,
            showSuccessAlert: false,
            alert: '',
            formData: {
                id: '',
                iin: '',
                name: '',
                industry: '',
                parentId: null,
                addressHome: null,
                phoneNumber: null,
                isNdsPayer: false,
                ndsCertificateSeries: '',
                ndsCertificateNumber: ''
            },
            oldAddress: null,
            selectedCity: null,
            selectedStreet: null,
            cities: [],
            streets: [],
            houses: []
        }
    },
    computed: {
        isDisabled() {
            return this.$store.getters.isLoading;
        }
    },
    methods: {
        getDealerData() {
            const onSuccess = response => {
                const dealer = response[0];
                this.formData.id = dealer.id;
                this.formData.iin = dealer.iin;
                this.formData.name = dealer.name;
                this.formData.industry = dealer.industry;
                this.formData.phoneNumber = dealer.phoneNumber;
                this.formData.isNdsPayer = dealer.isNdsPayer;
                this.formData.ndsCertificateSeries = dealer.ndsCertificateSeries;
                this.formData.ndsCertificateNumber = dealer.ndsCertificateNumber;
                this.oldAddress = dealer.address;
            };

            this.$request.sendRequest(
                this, 
                this.$appConfig.apiUrls.dealer.getAll,
                { id: this.dealerId },
                onSuccess, 
                this.displayAlert);
        },
        findCity: executeAfterTwoSeconds(function(query) {
            if (query.length < 3)
                return;

            const request = {
                data: { address: query },
                onSuccess: cities => this.cities = cities,
                onError: this.displayAlert 
            };

            this.$request.getCities(this, request);
        }),
        findAddress: executeAfterTwoSeconds(function (query) {
            if (query.length < 3)
                return;

            const request = {
                data: { 
                    address: query,
                    parentId: this.selectedCity.pointId 
                },
                onSuccess: streets => this.streets = streets,
                onError: this.displayAlert 
            };

            this.$request.getStreets(this, request);
        }),
        addressSelected: executeAfterTwoSeconds(function (house) {
            this.formData.parentId = house != null 
                ? house.id 
                : null;
            
            const request = {
                data: { parentId: this.formData.parentId },
                onSuccess: houses => this.houses = houses,
                onError: this.displayAlert 
            };

            this.$request.getHouses(this, request);
        }),
        updateDealer() {
            this.hideAlert();
            if (this.formData.parentId !== null && (this.formData.addressHome === null || this.formData.addressHome.trim() === '')) {
                this.displayAlert('addressMustBeSet');
                return;
            }

            if (this.formData.phoneNumber != null)
                this.formData.phoneNumber = this.formData.phoneNumber.replace(/\D/g, '');

            const onSuccess = response => {
                this.showSuccessAlert = true;
                this.alert = this.$i18n.t('dealer.updatedMessage');
            };

            this.$request.sendRequest(
                this, this.$appConfig.apiUrls.dealer.update,
                this.formData,
                onSuccess,
                this.displayAlert);
        },
        hideAlert() {
            this.showAlert = false;
            this.showSuccessAlert = false;
            this.alert = '';
        },
        displayAlert(errorCode) {
            this.alert = this.$i18n.t(`errors.${errorCode}`);
            this.showAlert = true;
        }
    }
}
</script>
